import Axios from '@/plugins/Axios';

import { RequestOtpPayload, ValidateOtpPayload } from '@/types';

const endpoint = '/otp';
const doctorEndpoint = '/b2b/otp';

const OtpApi = {
  requestOtp: (data: RequestOtpPayload) => Axios().post(endpoint, data),
  validateOtp: (data: ValidateOtpPayload) => Axios().put(endpoint, data),
  requestDoctorOtp: (data: RequestOtpPayload) =>
    Axios().post(doctorEndpoint, data),
  validateDoctorOtp: (data: ValidateOtpPayload) =>
    Axios().put(doctorEndpoint, data),
};

export default OtpApi;
